import {FormioBase} from "./formiobase";

export class Htmlelement extends FormioBase {
  public inputType = "htmlelement";
  public title = "Label";
  public icon = "fa-fachecksquare";
  public isAvailable = false;
  public schema: any = {
    title: "Label",
    components: [
      {
        key: "",
        input: false,
        tag: "label",
        className: "",
        content: "",
        type: "htmlelement",
        inputType: "htmlelement",
        hideLabel: false,
        tags: [],
        customClass: "ds-htmlelement",
      },
    ],
  };
}
